import { axiosInstance } from '../utils/axios';

export const getSuggestedTags = (
  { type, orgId, streamId, channelId, userTagInput, count, offset },
  extraData,
) =>
  axiosInstance.get(`/${orgId}/${streamId}/${channelId}/suggest`, {
    ...extraData,
    params: {
      ...extraData?.params,
      q: userTagInput,
      count,
      offset,
      type,
    },
  });
